module.exports = __webpack_public_path__ + "static/media/d6.4d398eaa.jpg";